import * as o from "react";
import i from "../lib/IconBase.es.js";
import e from "../defs/HandPointing.es.js";
const n = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(i, { ref: a, ...t, weights: e }));
n.displayName = "HandPointingIcon";
const c = n;
export {
  c as HandPointing,
  n as HandPointingIcon
};
